import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import MapboxGLMap from 'react-map-gl';
import { Marker } from './marker/marker';
import { MarkerPopup } from './marker-popup/marker-popup';
import { getBound } from './utils/fit-bounds';
import useMapReactions from './use-map-reactions';
/**
 * If you want map to wrap all points use "fitBound" = true
 * If you want map to wrap all points at initial render state use "fitBound" = true and specified "style" with { "height" and "width" }
 * @param props
 * @constructor
 */
export function Map(props) {
    const { defaultCenter, defaultZoom = 12, markers, style, fitBound, getPopupContent, accessToken, popupClassName, flyToCoordinates, selectedMarker: selectedMarkerProp, onPopupClose, } = props;
    const mapRef = useRef();
    const [selectedMarker, setSelectedMarker] = useState();
    const [mapLoaded, setMapLoaded] = useState(false);
    useMapReactions({
        mapRef: mapRef.current,
        mapLoaded,
        fitBound,
        markers,
        flyToCoordinates,
        innerSelectedMarker: selectedMarker,
        outerSelectedMarker: selectedMarkerProp,
        setSelectedMarker,
    });
    const initialBound = fitBound &&
        (style === null || style === void 0 ? void 0 : style.width) &&
        (style === null || style === void 0 ? void 0 : style.width) !== 'auto' &&
        (style === null || style === void 0 ? void 0 : style.height) &&
        (style === null || style === void 0 ? void 0 : style.height) !== 'auto'
        ? getBound(markers, {
            viewportSize: {
                width: parseInt(style === null || style === void 0 ? void 0 : style.width),
                height: parseInt(style === null || style === void 0 ? void 0 : style.height),
            },
        })
        : undefined;
    const onMarkerClick = (markerData) => {
        setSelectedMarker(markerData);
    };
    const onMarkerPopupClose = () => {
        setSelectedMarker(undefined);
        onPopupClose === null || onPopupClose === void 0 ? void 0 : onPopupClose();
    };
    return (_jsxs(MapboxGLMap
    // @ts-ignore
    , { 
        // @ts-ignore
        ref: mapRef, onRender: (event) => event.target.resize(), onLoad: () => setMapLoaded(true), mapboxAccessToken: accessToken, mapLib: import('mapbox-gl'), initialViewState: {
            latitude: (initialBound === null || initialBound === void 0 ? void 0 : initialBound.latitude) || (defaultCenter === null || defaultCenter === void 0 ? void 0 : defaultCenter.latitude) || 43.0338861771647,
            longitude: (initialBound === null || initialBound === void 0 ? void 0 : initialBound.longitude) ||
                (defaultCenter === null || defaultCenter === void 0 ? void 0 : defaultCenter.longitude) ||
                -76.16803413483689,
            zoom: (initialBound === null || initialBound === void 0 ? void 0 : initialBound.zoom) || defaultZoom,
        }, style: Object.assign({ width: '100%', height: '100%' }, style), mapStyle: "mapbox://styles/mapbox/streets-v9", children: [markers.map((marker, i) => (_jsx(Marker, Object.assign({}, marker, { onClick: onMarkerClick }), i))), selectedMarker && !!getPopupContent && (_jsx(MarkerPopup, { className: popupClassName, latitude: selectedMarker.latitude, longitude: selectedMarker.longitude, onClose: onMarkerPopupClose, children: getPopupContent === null || getPopupContent === void 0 ? void 0 : getPopupContent(selectedMarker.data) }))] }));
}
export default Map;
